import INSTALLER_JSON_RAW from './installer-urls.json';
import { Product as CloudCoreProducts } from '@portal/portal-core';

interface Installer {
  os: string;
  bits: string | null;
  path: string;
}

interface Deployment {
  cloudUrl: string;
  installerBaseUrl: string;
  latest: Record<string, string>;
  // Version keys (e.g. "10.8.1") map to arrays of installers.
  [version: string]: string | Record<string, string> | Installer[];
}

// The JSON is imported with resolveJsonModule; cast to the domain shape.
const INSTALLER_JSON = INSTALLER_JSON_RAW as unknown as Record<
  string,
  Deployment[]
>;

export const getlatestInstallerFromJson = (
  Product: string | null = null,
  OS: string | null = null,
  Region: string = 'https://cloud.flowjo.com',
): string | undefined => {
  const os = OS!.toLowerCase();
  const region = Region.toLowerCase();
  const lowercasedProduct = Product!.toLowerCase();
  if (lowercasedProduct === CloudCoreProducts.NAMES.flowJo.toLowerCase()) {
    const deployments = INSTALLER_JSON[lowercasedProduct];
    const chinaInstallerInfo = deployments.find((deployment) => {
      return deployment.cloudUrl === region;
    });
    const globalInstallerInfo = deployments.find((deployment) => {
      return deployment.cloudUrl === region;
    });
    if (chinaInstallerInfo) {
      const { installerBaseUrl } = chinaInstallerInfo;
      const latestVersionChinaMacOS = chinaInstallerInfo.latest[os];
      const latestVersionChinaWindows = chinaInstallerInfo.latest[os];
      const chinaMacOS = chinaInstallerInfo[latestVersionChinaMacOS] as Installer[];
      const chinaWindows = chinaInstallerInfo[
        latestVersionChinaWindows
      ] as Installer[];
      if (os === 'macos') {
        const chinaInstallerMacOS = chinaMacOS.find((installer) => {
          return installer.os === os;
        });
        return installerBaseUrl + chinaInstallerMacOS!.path;
      }
      if (os === 'windows') {
        const chinaInstallerWindows = chinaWindows.find(function (installer) {
          return installer.os === os && installer.bits === '64bit';
        });
        return installerBaseUrl + chinaInstallerWindows!.path;
      }
    } else {
      const { installerBaseUrl } = globalInstallerInfo!;
      const latestVersionGlobalMacOS = globalInstallerInfo!.latest[os];
      const latestVersionGlobalWindows = globalInstallerInfo!.latest[os];
      const globalMacOS = globalInstallerInfo![
        latestVersionGlobalMacOS
      ] as Installer[];
      const globalWindows = globalInstallerInfo![
        latestVersionGlobalWindows
      ] as Installer[];
      if (os === 'macos') {
        const globalInstallerMacOS = globalMacOS.find((installer) => {
          return installer.os === os;
        });
        return installerBaseUrl + globalInstallerMacOS!.path;
      }
      if (os === 'windows') {
        const globalInstallerWindows = globalWindows.find((installer) => {
          return installer.os === os && installer.bits === '64bit';
        });
        return installerBaseUrl + globalInstallerWindows!.path;
      }
    }
  }
  if (lowercasedProduct === CloudCoreProducts.NAMES.seqGeq.toLowerCase()) {
    const deployments = INSTALLER_JSON[lowercasedProduct];
    const chinaInstallerInfo = deployments.find((deployment) => {
      return deployment.cloudUrl === region;
    });
    const globalInstallerInfo = deployments.find((deployment) => {
      return deployment.cloudUrl === region;
    });
    if (chinaInstallerInfo) {
      const { installerBaseUrl } = chinaInstallerInfo;
      const latestVersionChinaMacOS = chinaInstallerInfo.latest[os];
      const latestVersionChinaWindows = chinaInstallerInfo.latest[os];
      const chinaMacOS = chinaInstallerInfo[latestVersionChinaMacOS] as Installer[];
      const chinaWindows = chinaInstallerInfo[
        latestVersionChinaWindows
      ] as Installer[];
      if (os === 'macos') {
        const chinaInstallerMacOS = chinaMacOS.find((installer) => {
          return installer.os === os;
        });
        return installerBaseUrl + chinaInstallerMacOS!.path;
      }
      if (os === 'windows') {
        const chinaInstallerWindows = chinaWindows.find(function (installer) {
          return installer.os === os && installer.bits === '64bit';
        });
        return installerBaseUrl + chinaInstallerWindows!.path;
      }
    } else {
      const { installerBaseUrl } = globalInstallerInfo!;
      const latestVersionGlobalMacOS = globalInstallerInfo!.latest[os];
      const latestVersionGlobalWindows = globalInstallerInfo!.latest[os];
      const globalMacOS = globalInstallerInfo![
        latestVersionGlobalMacOS
      ] as Installer[];
      const globalWindows = globalInstallerInfo![
        latestVersionGlobalWindows
      ] as Installer[];
      if (os === 'macos') {
        const globalInstallerMacOS = globalMacOS.find((installer) => {
          return installer.os === os;
        });
        return installerBaseUrl + globalInstallerMacOS!.path;
      }
      if (os === 'windows') {
        const globalInstallerWindows = globalWindows.find((installer) => {
          return installer.os === os && installer.bits === '64bit';
        });
        return installerBaseUrl + globalInstallerWindows!.path;
      }
    }
  }
  return undefined;
};
